import { useState } from "react"
import { Menu, LogOut } from "lucide-react"
import { AppSidebar } from "@/components/AppSidebar"
import { useIsMobile } from "@/hooks/use-mobile"
import { useAuth } from "@/hooks/useAuth"
import { Button } from "@/components/ui/button"

interface MainLayoutProps {
  children: React.ReactNode
}

export function MainLayout({ children }: MainLayoutProps) {
  const [collapsed, setCollapsed] = useState(false)
  const isMobile = useIsMobile()
  const { signOut, user } = useAuth()

  const toggleSidebar = () => {
    setCollapsed(!collapsed)
  }

  return (
    <div className="h-screen flex w-full overflow-hidden">
      {/* Mobile header with hamburger button */}
      <header className="fixed top-0 left-0 right-0 h-12 flex items-center justify-between border-b bg-background z-50 md:hidden">
        <div className="flex items-center">
          <Button
            variant="ghost"
            size="sm"
            onClick={toggleSidebar}
            className="ml-3 h-8 w-8 p-0"
          >
            <Menu className="h-4 w-4" />
          </Button>
          <h1 className="ml-3 font-medium">訂單管理系統</h1>
        </div>
      </header>

      <AppSidebar collapsed={collapsed} onToggle={toggleSidebar} />
      
      <main className={`flex-1 flex flex-col overflow-auto ${isMobile ? 'pt-12' : ''}`}>
        {children}
      </main>
      
      {/* Mobile overlay */}
      {isMobile && !collapsed && (
        <div 
          className="fixed inset-0 bg-black/50 z-40" 
          onClick={toggleSidebar}
        />
      )}
    </div>
  )
}